import React, { useMemo } from 'react';
import { Form } from 'formik';
import { FormGroup, ToggleButtonGroup } from '../../../form';
import {
  InputText,
  InputUpperCase,
  InputTelephone,
  InputEmail,
} from '../../../formikBindings';
import { StepperButtons } from '../../../stepper';
import { IVisitorDetailsFormProps } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  INormalizedObjects,
  INormalizedVisitorTypeDetails,
  useAuthentication,
} from '../../../authentiction';
import { IVisitorTypeFormValues } from '../../../admin/visitorTypes/form';

const getVisitorTypeList = (
  normalizedData?: INormalizedObjects<INormalizedVisitorTypeDetails>,
): Array<IVisitorTypeFormValues> => {
  if (!normalizedData) return [];

  return normalizedData.allIds.map((id) => ({
    id,
    name: normalizedData.byId[id].name,
    icon: normalizedData.byId[id].icon,
  }));
};

const VisitorDetailsForm: React.FC<IVisitorDetailsFormProps> = ({
  visitorTypeId,
  onVisitorTypeChange,
}) => {
  const { visitorTypes } = useAuthentication();

  const memoizedVisitorTypes = useMemo(
    () => getVisitorTypeList(visitorTypes),
    [visitorTypes],
  );

  const renderToggleButton = (visitorType: IVisitorTypeFormValues) => (
    <ToggleButtonGroup.Button
      key={visitorType.id}
      id={visitorType.id.toString()}
    >
      <FontAwesomeIcon icon={visitorType.icon} size="2x" />
      <div>{visitorType.name}</div>
    </ToggleButtonGroup.Button>
  );

  return (
    <Form autoComplete="off">
      <FormGroup name="visitorTypeId" label="Visitor Type" required>
        <ToggleButtonGroup
          activeKey={visitorTypeId.toString()}
          onChange={(value) => onVisitorTypeChange(+value)}
        >
          {memoizedVisitorTypes.map(renderToggleButton)}
        </ToggleButtonGroup>
      </FormGroup>
      <FormGroup name="firstNames" label="First Name" required>
        <InputText name="firstNames" maxLength={100} isValidIndicator />
      </FormGroup>
      <FormGroup name="surname" label="Surname" required>
        <InputText name="surname" maxLength={100} isValidIndicator />
      </FormGroup>
      <FormGroup name="company" label="Company">
        <InputText name="company" maxLength={100} isValidIndicator />
      </FormGroup>
      <FormGroup name="carRegistration" label="Car Registration">
        <InputUpperCase
          name="carRegistration"
          maxLength={10}
          isValidIndicator
        />
      </FormGroup>
      <FormGroup name="emailAddress" label="Email Address">
        <InputEmail name="emailAddress" maxLength={256} isValidIndicator />
      </FormGroup>
      <FormGroup name="mobile" label="Mobile">
        <InputTelephone name="mobile" maxLength={20} isValidIndicator />
      </FormGroup>
      <FormGroup name="host" label="Here To See" required>
        <InputText name="host" maxLength={100} isValidIndicator />
      </FormGroup>
      <StepperButtons submitMode finishLabel="Sign In" />
    </Form>
  );
};

export default VisitorDetailsForm;
